import React from 'react';
import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { getBorderColor, getBorderColorActive } from '../../../theme/Components';

const CustomDatePicker = styled(({ MenuProps, ...props }) => <DatePicker {...props} />)(
  ({ theme }) => ({
    '& fieldset': {
      borderColor: getBorderColor(theme)
    },
    '&:hover fieldset': {
      borderColor: getBorderColorActive(theme)
    }
  })
);

export default CustomDatePicker;
